// @flow
import {cookieOptions, writeCookie, readCookie} from './cookieUtils';
import {includes, isEmpty} from 'lodash';

export const DEMOTED_HITS_COOKIE = 'ha-demoted-hits';
export const DEMOTED_HITS_LIMIT = 30;

export const getDemotedHits = () => {
    const cookieData = readCookie(DEMOTED_HITS_COOKIE);
    return !isEmpty(cookieData) ? cookieData : [];
};

export const demoteHit = (listingNumber: ?number) => {
    const demotedHits = getDemotedHits();
    // if demoted list does not contain this hit add it to cookie
    if (listingNumber && !includes(demotedHits, listingNumber.toString())) {
        if (demotedHits.length >= DEMOTED_HITS_LIMIT) {
            demotedHits.shift();
        }
        demotedHits.push(listingNumber.toString());
        writeCookie(DEMOTED_HITS_COOKIE, demotedHits, cookieOptions);
    }
};
